// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_layout__vMEB8 {
  display: grid;
  grid-template-columns: 250px 1fr;
}

@media (max-width: 1368px) {
  .layout_layout__vMEB8 {
    grid-template-columns: min-content 1fr;
  }
}

@media (max-width: 768px) {
  .layout_layout__vMEB8 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr min-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;AACF","sourcesContent":[".layout {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n}\n\n@media (max-width: 1368px) {\n  .layout {\n    grid-template-columns: min-content 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr min-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `layout_layout__vMEB8`
};
export default ___CSS_LOADER_EXPORT___;
